import React, { useMemo } from "react";
import InfoCard from "./InfoCard";
import { useTranslation } from "react-i18next";
import Styles from "../../../scss/orderDetails.module.scss";
import { IPlacedOrder } from "../constants";
import { toLocalDate, toLocalTime } from "../../../yoello-lib/modules/utils/TimeConversion";
import * as moment from 'moment';
import 'moment-duration-format';
import { OrderTypeDetails } from "./OrderTypeDetails";
import { ICollectionPoint } from "../../ordersSetting/Forms/CollectionPointEntity";

interface IOrderDetailsProps {
    placed_order: IPlacedOrder;
    collectionPoints: ICollectionPoint[],
    orderOnly ?: boolean
}


export function OrderDetails({ placed_order, collectionPoints , orderOnly }: IOrderDetailsProps) {
    const { t } = useTranslation();

    const timeDif = useMemo(() => {
        if (!placed_order) return 0;
        return timeDifference(new Date(Date.parse(placed_order.placed_order_created_on || "")), new Date());
    }, [placed_order]);

    return <div className={Styles.orderInfoDetails}>
        <OrderTypeDetails placed_order={placed_order} collectionPoints={collectionPoints} orderOnly={orderOnly} />
        <div className={Styles.TimeAndDateSection}>
            {placed_order &&
                <>
                    <InfoCard label={t("orderHistory.modal.elapsed")} wrapperClassName={Styles.Elapsed} value={timeDif} className={Styles.label} />
                    <InfoCard label={t("orderHistory.modal.orderTime")} value={toLocalTime(placed_order.placed_order_created_on)} className={Styles.label} />
                    <InfoCard label={t("orderHistory.modal.orderDate")} value={toLocalDate(placed_order.placed_order_created_on)} className={Styles.label} />
                </>
            }

        </div>
    </div>
}

function timeDifference(dateStart: Date, dateEnd: Date): string {
    const mStart = moment(dateStart);
    const mEnd = moment(dateEnd);
    return moment.duration(mStart.diff(mEnd)).humanize();
}